/* eslint-disable */
import React from 'react';

// Onboarding tour disabled in standalone admin app (react-joyride not compatible with React 18)
const AdminOnboardingTour = ({ open, onClose }) => {
  return null;
};

export default AdminOnboardingTour;
